import { acorekey, acorekeyvalue, acoreversionkey, acoreversion830value } from '@/constants';
/**
 * 浅比较两个对象
 *
 * @param o1
 * @param o2
 * @example
 *
 * isObjectShadowEq({a: 1}, {a: 1})
 * // true
 *
 * isObjectShadowEq({a: 1}, {b: 1})
 * // false
 */
function isObjShadowEq(o1: any, o2: any) {
  var props1 = Object.getOwnPropertyNames(o1);
  var props2 = Object.getOwnPropertyNames(o2);
  if (props1.length !== props2.length) {
    return false;
  }
  for (var i = 0, max = props1.length; i < max; i++) {
    var propName = props1[i];
    if (o1[propName] !== o2[propName]) {
      return false;
    }
  }
  return true;
}

/**
 * 深对比两个对象
 *
 * @param val1
 * @param val2
 * @example
 *
 * deepEq({a: {a: 1}}, {a: {a: 1}})
 * // true
 */
function deepEq(valone: any, valtwo: any) {
  // 辅助空间防止循环引用
  const stack1 = <any>[];
  const stack2 = <any>[];

  return _deepEq(valone, valtwo);

  function _deepEq(val1: any, val2: any) {
    if (Object.is(val1, val2)) return true;

    // 只要有一个不是对象则返回false
    if (typeof val1 !== 'object' || val1 === null || typeof val2 !== 'object' || val2 === null) return false;

    const loopReference = stack1.indexOf(val1);

    if (loopReference !== -1) {
      if (stack2[loopReference] === val2) return true;
      else return false;
    }

    stack1.push(val1);
    stack2.push(val2);

    // 开始对比两个对象
    const keys1 = Object.keys(val1);
    const keys2 = Object.keys(val2);
    if (keys1.length !== keys2.length) return false;
    let key = null;

    for (var i = 0, len = keys1.length; i < len; i++) {
      key = keys1[i];
      if (!_deepEq(val1[key], val2[key])) return false;
    }

    stack1.pop();
    stack2.pop();

    return true;
  }
}

/**
 * 获取部门，将一级部门去除
 *
 * @param department
 * @param splitString
 * @example
 *
 * getDepartment('a-b-c')
 * // 'b-c'
 */
function getDepartment(department: string, splitString = '-') {
  if (typeof department !== 'string') return department;

  const depart = department.split(splitString).slice(1);
  return depart.join(splitString);
}

/**
 * 获取第 n 级部门
 *
 * @param organization
 * @param splitString
 * @param level
 * @example
 *
 * extractOrganization('a-b-c-d')
 * // 'c'
 *
 * extractOrganization('a&b&c&d', '&')
 * // 'c'
 */
function extractOrganization(organization: string, splitString = '-', level = 3 /* 需要几级部门 */) {
  if (typeof organization !== 'string') return organization;
  if (typeof level !== 'number') return organization;
  if (level < 1) {
    console.error('部门从1级开始算');
    return organization;
  }

  const organizations = organization.split(splitString);

  return organizations.length < level ? organizations[organizations.length - 1] : organizations[level - 1];
}

/**
 * 将选项的第一个全部或者其它的改成入参 title
 *
 * @param list
 * @param title
 * @example
 *
 * transformConstantsList([{title: '', val: ''}], 'title')
 * // [{title: 'title', val: ''}]
 */
function transformConstantsList(list: any, title: string) {
  const _list = list.slice();

  const first = _list.shift();

  const copyFirst = Object.assign({}, first);

  copyFirst.title = title;

  _list.unshift(copyFirst);

  return _list;
}

function getUnicode(len = 32) {
  var t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var a = t.length;
  var n = '';
  for (let i = 0; i < len; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n;
}

// 计算字符串所占的字节长度,  中文字符长度占2，英文字符占1
function getBytesLength(str: String) {
  const reg = new RegExp(
    [
      '[(\u4e00-\u9fa5)|\u3002|\uff1f|\uff01|',
      '\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|',
      '\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|',
      '\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|',
      '\u2026|\u2014|\uff5e|\ufe4f|\uffe5]{1}',
    ].join(''),
    'g'
  );
  return str.replace(reg, 'sB').length;
}

/**
 * 给链接添加来源和版本
 *
 * @param link
 * @param acoreversion
 * @param noHashRouter
 * @returns
 */
function linkWhereFrom(link: string, acoreversion?: string | number, noHashRouter?: boolean): string {
  if (typeof link !== 'string') return link;

  let linkFromAcore = '';

  if (link.indexOf(acorekey) === -1) linkFromAcore = `${acorekey}=${acorekeyvalue}`;

  if (acoreversion && link.indexOf(acoreversionkey) === -1) {
    linkFromAcore += (linkFromAcore ? '&' : '') + `${acoreversionkey}=${acoreversion}`;
  }

  const hashIndex = link.indexOf('#');

  if (hashIndex !== -1) {
    return (
      link.slice(0, hashIndex) +
      // linkWhereFrom(link.slice(0, hashIndex), acoreversion, noHashRouter) +
      '#' +
      (noHashRouter ? link.slice(hashIndex + 1) : linkWhereFrom(link.slice(hashIndex + 1), acoreversion, noHashRouter))
    );
  }

  const searchIndex = link.indexOf('?');

  let query = '';
  let prefixLink = '';

  if (searchIndex !== -1) {
    query = link.slice(searchIndex);
    prefixLink = link.slice(0, searchIndex);
  } else {
    query = '?';
    prefixLink = link;
  }

  if (query.length > 1 && linkFromAcore.length) {
    query += '&';
  }

  query += linkFromAcore;

  return `${prefixLink}${query}`;
}

function linkWhereFromAndVersion830(link: string, noHashRouter?: boolean) {
  return linkWhereFrom(link, acoreversion830value, noHashRouter);
}

// 下划线转换驼峰
function stringToHump(name: string) {
  return name.replace(/\_(\w)/g, function (all, letter) {
    return letter.toUpperCase();
  });
}
// 驼峰转换下划线
function stringToLine(name: string) {
  return name.replace(/([A-Z])/g, '_$1').toLowerCase();
}

export {
  stringToHump,
  stringToLine,
  isObjShadowEq,
  deepEq,
  getDepartment,
  extractOrganization,
  transformConstantsList,
  getUnicode,
  getBytesLength,
  linkWhereFrom,
  linkWhereFromAndVersion830,
};
